// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file dump/common.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message com.neulink.pharmacy.DumpItems
 */
export class DumpItems extends Message<DumpItems> {
  /**
   * @generated from field: string trade_name = 1;
   */
  tradeName = "";

  /**
   * @generated from field: int32 unit = 2;
   */
  unit = 0;

  /**
   * @generated from field: string unit_type = 3;
   */
  unitType = "";

  /**
   * @generated from field: string manufacturer = 4;
   */
  manufacturer = "";

  /**
   * @generated from field: string owner = 5;
   */
  owner = "";

  /**
   * @generated from field: string category = 6;
   */
  category = "";

  /**
   * @generated from field: string sub_category = 7;
   */
  subCategory = "";

  /**
   * @generated from field: double vat = 8;
   */
  vat = 0;

  /**
   * @generated from field: string barcode = 9;
   */
  barcode = "";

  /**
   * @generated from field: repeated com.neulink.pharmacy.DumpInventory inventory = 10;
   */
  inventory: DumpInventory[] = [];

  constructor(data?: PartialMessage<DumpItems>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.DumpItems";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "trade_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "unit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "unit_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "manufacturer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "owner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "sub_category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "vat", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "barcode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "inventory", kind: "message", T: DumpInventory, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DumpItems {
    return new DumpItems().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DumpItems {
    return new DumpItems().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DumpItems {
    return new DumpItems().fromJsonString(jsonString, options);
  }

  static equals(a: DumpItems | PlainMessage<DumpItems> | undefined, b: DumpItems | PlainMessage<DumpItems> | undefined): boolean {
    return proto3.util.equals(DumpItems, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.DumpInventory
 */
export class DumpInventory extends Message<DumpInventory> {
  /**
   * @generated from field: string batch_number = 1;
   */
  batchNumber = "";

  /**
   * @generated from field: string expiry_date = 2;
   */
  expiryDate = "";

  /**
   * @generated from field: double price = 3;
   */
  price = 0;

  /**
   * @generated from field: double quantity = 4;
   */
  quantity = 0;

  /**
   * @generated from field: double cost = 5;
   */
  cost = 0;

  /**
   * @generated from field: string custom_barcode = 6;
   */
  customBarcode = "";

  constructor(data?: PartialMessage<DumpInventory>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.DumpInventory";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "batch_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "expiry_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "cost", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "custom_barcode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DumpInventory {
    return new DumpInventory().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DumpInventory {
    return new DumpInventory().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DumpInventory {
    return new DumpInventory().fromJsonString(jsonString, options);
  }

  static equals(a: DumpInventory | PlainMessage<DumpInventory> | undefined, b: DumpInventory | PlainMessage<DumpInventory> | undefined): boolean {
    return proto3.util.equals(DumpInventory, a, b);
  }
}

